import { useState } from "react";
import { FadeUp, SectionTag } from "../components/site/Reveal";

export default function LeakCalculator({ dark = true }) {
  const [jobs, setJobs] = useState(12);
  const [value, setValue] = useState(350);
  const [hours, setHours] = useState(10);

  const lostQuotes = Math.round(jobs * 4 * 0.2); // ~20% of leads never quoted fast enough
  const lostRevenue = lostQuotes * value;
  const adminCost = hours * 4 * 45; // 4 weeks at $45/hr owner time

  const wrap = dark ? "text-white" : "text-navy";
  const sub = dark ? "text-slate-400" : "text-slate-600";

  return (
    <div data-testid="leak-calculator" className={`border ${dark ? "border-white/10 bg-charcoal/60" : "border-slate-200 bg-white"} p-6 sm:p-10`}>
      <SectionTag>Interactive // The Leak Meter</SectionTag>
      <h3 className={`font-display font-extrabold text-2xl sm:text-3xl tracking-tight mt-4 ${wrap}`}>
        What is the back-office chaos costing you?
      </h3>
      <div className="grid sm:grid-cols-3 gap-8 mt-8">
        {[
          { label: "Jobs per week", val: jobs, set: setJobs, min: 2, max: 40, id: "jobs" },
          { label: "Average job value ($)", val: value, set: setValue, min: 50, max: 2000, step: 25, id: "value" },
          { label: "Admin hours per week", val: hours, set: setHours, min: 1, max: 40, id: "hours" },
        ].map((s) => (
          <div key={s.id}>
            <div className="flex justify-between mb-2">
              <label className={`text-sm font-medium ${sub}`}>{s.label}</label>
              <span className="font-mono text-safety text-sm">{s.id === "value" ? `$${s.val}` : s.val}</span>
            </div>
            <input
              type="range"
              data-testid={`calc-slider-${s.id}`}
              min={s.min}
              max={s.max}
              step={s.step || 1}
              value={s.val}
              onChange={(e) => s.set(Number(e.target.value))}
              className="w-full accent-[#FF5500]"
            />
          </div>
        ))}
      </div>
      <FadeUp className="grid sm:grid-cols-3 gap-6 mt-10 pt-8 border-t border-dashed border-slate-500/30">
        <div>
          <p className="font-mono text-3xl sm:text-4xl font-bold text-safety" data-testid="calc-lost-quotes">{lostQuotes}</p>
          <p className={`text-sm mt-1 ${sub}`}>est. quotes lost per month to slow follow-up</p>
        </div>
        <div>
          <p className="font-mono text-3xl sm:text-4xl font-bold text-safety" data-testid="calc-lost-revenue">${lostRevenue.toLocaleString()}</p>
          <p className={`text-sm mt-1 ${sub}`}>est. revenue leaking every month</p>
        </div>
        <div>
          <p className="font-mono text-3xl sm:text-4xl font-bold text-safety" data-testid="calc-admin-cost">${adminCost.toLocaleString()}</p>
          <p className={`text-sm mt-1 ${sub}`}>of your time burned on admin monthly</p>
        </div>
      </FadeUp>
      <p className={`font-mono text-[11px] uppercase tracking-[0.18em] mt-8 ${dark ? "text-slate-500" : "text-slate-400"}`}>
        [Estimates only — your audit in Module 01 gets the real numbers]
      </p>
    </div>
  );
}
